import { render, staticRenderFns } from "./right_panel_performance_table.vue?vue&type=template&id=722002c8&scoped=true"
import script from "./right_panel_performance_table.vue?vue&type=script&lang=js"
export * from "./right_panel_performance_table.vue?vue&type=script&lang=js"
import style0 from "./right_panel_performance_table.vue?vue&type=style&index=0&id=722002c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722002c8",
  null
  
)

export default component.exports